import React from 'react';
import styled, { css } from 'styled-components/macro';
import { Box, Text, UnmountClosed, mixins, Link } from '@stashinvest/ui';
import { BanjoString } from '@stashinvest/react-banjo';

const disclosureStyles = css`
	${mixins.caption}
	color: ${({ color, theme }) =>
		color ? theme.colors[color] : theme.colors.textSecondary};
`;

const DisclosureParagraph = styled.p`
	${disclosureStyles}
`;
const DisclosureLink = styled.a`
	${disclosureStyles}
	text-decoration: underline;
	cursor: pointer;
	&:hover {
		text-decoration: underline;
	}
`;
const FakeDisclosureLink = styled.span`
	${disclosureStyles}
	text-decoration: underline;
	cursor: pointer;
	&:hover {
		text-decoration: underline;
	}
`;

const FooterWrap = styled.footer`
	margin-top: 2em;
	padding: ${({ theme }) => theme.space.l};
	background: ${({ theme }) => theme.colors.bgPrimary};
`;

const InnerWrap = styled.div`
	max-width: 1024px;
	margin: 0 auto;
`;

const FooterDisclosureList = styled.ul`
	li {
		margin-bottom: 1em;
	}
`;

const StyledContainer = styled(Box)`
	padding: 2em;
	width: '100%';
	max-width: '100%';
	text-align: center;

	margin: ${({ theme }) => `0 0 ${theme.space.m}`};

	${({ theme }) => theme.mediaQueries.tablet} {
		padding: 2em 2em 6em 2em;
	}
`;

export const ShortFooter = () => {
	return (
		<StyledContainer center>
			<Text>
				<span>&copy; Stash Financial, Inc. | </span>
				<span>
					<Link
						color="textSecondary"
						href="https://www.stash.com/disclosurelibrary"
						target="_blank"
						rel="noopener noreferrer"
					>
						Disclosures
					</Link>
				</span>
			</Text>
		</StyledContainer>
	);
};

const renderFullFooter = () => (
	<div>
		<DisclosureParagraph mb="m">
			Stash Capital LLC, an SEC registered broker-dealer and member{' '}
			<DisclosureLink href="https://www.finra.org/" target="_blank">
				FINRA/SIPC
			</DisclosureLink>{' '}
			, serves as introducing broker for Stash Clients’ advisory accounts.{' '}
			<DisclosureLink href="https://www.apexclearing.com/" target="_blank">
				Apex Clearing Corporation
			</DisclosureLink>
			, a third-party SEC registered broker-dealer and member{' '}
			<DisclosureLink href="https://www.finra.org/" target="_blank">
				FINRA/SIPC
			</DisclosureLink>
			, provides clearing and execution services and serves as qualified custodian for
			advisory assets of Stash Clients.
			<BanjoString stringId={`information/disclose/genericBankMention`} />{' '}
			<BanjoString stringId={`information/disclose/bankAndInvest`} /> For more
			information, see our{' '}
			<DisclosureLink href="https://www.stash.com/disclosurelibrary" target="_blank">
				disclosures
			</DisclosureLink>
		</DisclosureParagraph>
		<DisclosureParagraph mb="s">
			Email:{' '}
			<DisclosureLink href="mailto:support@stash.com">support@stash.com</DisclosureLink>{' '}
			Tel: <DisclosureLink href="tel:8002055164">(800) 205-5164</DisclosureLink>
		</DisclosureParagraph>
		<DisclosureParagraph mb="s">
			© Copyright 2024 Stash Financial, Inc. All rights reserved.
		</DisclosureParagraph>
	</div>
);
export class FullFooter extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isOpen: false,
		};
		this.handleClick = this.handleClick.bind(this);
	}
	handleClick() {
		const { isOpen } = this.state;
		this.setState({ isOpen: !isOpen });
	}
	render() {
		const { isOpen } = this.state;

		return (
			<FooterWrap>
				<InnerWrap>
					<Box mb="m">
						<FooterDisclosureList>
							<li>
								<Text.Caption>
									Stash Financial, Inc. is a digital financial services company offering
									financial products for U.S. based consumers. Stash is not a bank or
									depository institution licensed in any jurisdiction. Advisory products
									and services are offered through Stash Investments LLC, an SEC
									registered investment adviser.
								</Text.Caption>
							</li>
						</FooterDisclosureList>
					</Box>
					<UnmountClosed isOpened={isOpen}>{renderFullFooter()}</UnmountClosed>
					<FakeDisclosureLink onClick={this.handleClick}>
						{isOpen ? 'Click to read less' : 'Click to read more'}
					</FakeDisclosureLink>
				</InnerWrap>
			</FooterWrap>
		);
	}
}
